(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/utils/jupiter-pay.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/utils/jupiter-pay.js');

'use strict';

const asyncDrawsApi = svs.numbergames.draws.asyncDrawsApi;
svs.numbergames.game.utils.JupiterPay = _ref => {
  let {
    wagerModel,
    skipSuccessRedirect
  } = _ref;
  const {
    isProductFamily
  } = svs.numbergames.productMapping;
  const {
    PAYMENT_SUCCESS,
    DIALOG_SUCCESS_CONFIRM,
    PAYMENT_CANCEL,
    DIALOG_ERROR_CONFIRM,
    DIALOG_ACCOUNT_LOW_CANCEL,
    PAYMENT_ERROR_ERROR_DRAW_CLOSED
  } = svs.tur.payment.constants.events;
  const initPayment = () => {
    try {
      var _svs$numbergames$game;
      const alwaysPayable = (_svs$numbergames$game = svs.numbergames.game_model.rulesRadio.request('rules')) === null || _svs$numbergames$game === void 0 ? void 0 : _svs$numbergames$game.alwaysOpen;
      const payment = new svs.tur.payment.api.jupiter.numbergames.Pay({
        wagerModel,
        alwaysPayable
      });
      payment.on(DIALOG_ACCOUNT_LOW_CANCEL, () => svs.utils.paramHandler.remove({
        key: 'pay'
      }));
      payment.on(DIALOG_ERROR_CONFIRM, () => svs.utils.paramHandler.remove({
        key: 'pay'
      }));
      payment.on(PAYMENT_CANCEL, () => svs.utils.paramHandler.remove({
        key: 'pay'
      }));
      payment.on(PAYMENT_SUCCESS, () => {
        svs.utils.paramHandler.remove({
          key: 'pay'
        });
        wagerModel.removeFromLocalStorage();
      });
      payment.on(DIALOG_SUCCESS_CONFIRM, () => {
        const returnUrl = svs.utils.paramHandler.get({
          key: 'returnUrl'
        });
        if (returnUrl.value) {
          svs.utils.url.navigate("".concat(svs.utils.url.makeInternal(decodeURIComponent(returnUrl.value), svs.core.urlMapping.get('myBetsHome'))));
        } else if (!skipSuccessRedirect) {
          svs.utils.url.navigate("".concat(svs.core.data.baseUrl, "/relaterat?grassrootstoasterredirect"));
        }
      });
      payment.on(PAYMENT_ERROR_ERROR_DRAW_CLOSED, async () => {
        svs.utils.paramHandler.remove({
          key: 'pay'
        });
        try {
          await asyncDrawsApi.firstPlayableDraw(wagerModel.get('productId'));
        } catch (e) {
          return payment.paymentErrorHandler.showErrorDialog();
        }
        let nextDrawDate;
        let upcomingDrawProduct;
        let {
          draw
        } = svs.numbergames.game;
        if (isProductFamily(wagerModel.get('productId'))) {
          const selectedDays = wagerModel.get('selectedDays');
          if (selectedDays.length === 1) {
            upcomingDrawProduct = svs.numbergames.game.draw.upcomingDrawProduct;
            draw = svs.numbergames.game.draw[upcomingDrawProduct];
            wagerModel.set({
              selectedDays: [upcomingDrawProduct]
            });
          } else {
            wagerModel.set({
              selectedDays: selectedDays.filter(day => day !== upcomingDrawProduct)
            });
          }
        }
        if (draw) {
          const {
            isOpen,
            closeTime
          } = draw;
          if (isOpen && closeTime) {
            nextDrawDate = closeTime;
          }
        }
        if (nextDrawDate) {
          payment.promptNextDraw({
            nextDrawDate,
            upcomingDrawProduct
          });
        } else {
          payment.paymentErrorHandler.showErrorDialog();
        }
      });
      payment.initialize();
    } catch (err) {
      svs.numbergames.game.logger.warn('Payment encountered an error:', err);
    }
  };
  initPayment();
};

 })(window);